<!-- Center canvas: summary, text typed into directly - whole card is one pinnable region
     (image + text + CTA together), matching v1's single right-side-container
     click area, unlike Main Banner (image-only content). -->
<div class="cr-ev-card" *ngIf="isPreview" [id]="block.blockId">
  <span class="cr-ev-badge">InspirationFotoDES</span>

  <div
    class="cr-ev-dropzone"
    [appInlineMedia]="currentDeviceImage"
    [inlineMediaBlockId]="block.blockId"
    (inlineMediaChange)="onChange($event, currentDeviceImageKey)"
  >
    <a *ngIf="currentDeviceImage; else emptyPreview" [href]="imagePreviewHref" target="_blank" rel="noopener">
      <img [src]="currentDeviceImage" [alt]="block.variables?.['EventImageAlt'] || ''" />
    </a>

    <ng-template #emptyPreview>
      <div class="cr-inline-media-icon">
        <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
          <path d="M7.4 18.3H6.2a4.2 4.2 0 0 1-.45-8.38A6.25 6.25 0 0 1 17.83 8.7a4.85 4.85 0 0 1 .02 9.6H16.6" />
          <path d="M12 19.2V11.7" />
          <path d="m8.9 14.8 3.1-3.1 3.1 3.1" />
        </svg>
      </div>
      <div class="cr-inline-media-title">Upload image</div>
      <div class="cr-inline-media-subtitle">PNG up to 2 mb</div>
    </ng-template>
  </div>

  <span
    class="cr-ev-text"
    [appInlineEdit]="block.variables?.EventText ?? ''"
    [inlineEditBlockId]="block.blockId"
    inlineEditPlaceholder="Insert text"
    [inlineEditMultiline]="true"
    (inlineEditChange)="onChange($event, 'EventText')"
  ></span>

  <a class="cr-ev-cta" [href]="ctaPreviewHref" target="_blank" rel="noopener">
    <span
      [appInlineEdit]="block.variables?.EventCtaText ?? ''"
      [inlineEditBlockId]="block.blockId"
      [inlineEditPlaceholder]="ctaButtonPlaceholder"
      (inlineEditChange)="onChange($event, 'EventCtaText')"
    ></span>
  </a>
</div>

<!-- Right panel: real edit form -->
<div class="cr-ev-edit" *ngIf="!isPreview">
  <div class="cr-ev-field-row">
    <span class="cr-ev-field-label">Desktop Image</span>
    <span
      class="cr-ev-toggle"
      [class.cr-ev-toggle-on]="desktopImageAsUpload"
      role="button"
      tabindex="0"
      [title]="desktopImageAsUpload ? 'Switch to entering an image link' : 'Switch to uploading an image'"
      (click)="toggleDesktopImageMode()"
      (keydown.enter)="toggleDesktopImageMode()"
      (keydown.space)="toggleDesktopImageMode()"
    ></span>
  </div>
  <div class="cr-ev-image-field">
    <app-block-text
      [maxLength]="500"
      type="link"
      [blockData]="block.variables?.['EventImageDesktop'] ?? ''"
      (handleOnChange)="onChange($event, 'EventImageDesktop')"
      [placeholder]="imageDesktopPlaceholder"
      variable="EventImageDesktop"
      [isImage]="desktopImageAsUpload"
      [isPlainText]="true"
      [blockId]="block.blockId"
    ></app-block-text>
    <div class="cr-ev-empty-overlay" *ngIf="desktopImageAsUpload && !block.variables?.['EventImageDesktop']">
      <div class="cr-ev-icon">
        <svg viewBox="0 0 24 24" width="24" height="24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round">
          <path d="M7.4 18.3H6.2a4.2 4.2 0 0 1-.45-8.38A6.25 6.25 0 0 1 17.83 8.7a4.85 4.85 0 0 1 .02 9.6H16.6" />
          <path d="M12 19.2V11.7" />
          <path d="m8.9 14.8 3.1-3.1 3.1 3.1" />
        </svg>
      </div>
      <div class="cr-ev-title">Upload image</div>
      <div class="cr-ev-subtitle">PNG up to 2 mb</div>
    </div>
  </div>

  <div class="cr-ev-field-row">
    <span class="cr-ev-field-label">Mobile Image</span>
    <span
      class="cr-ev-toggle"
      [class.cr-ev-toggle-on]="mobileImageAsUpload"
      role="button"
      tabindex="0"
      [title]="mobileImageAsUpload ? 'Switch to entering an image link' : 'Switch to uploading an image'"
      (click)="toggleMobileImageMode()"
      (keydown.enter)="toggleMobileImageMode()"
      (keydown.space)="toggleMobileImageMode()"
    ></span>
  </div>
  <div class="cr-ev-image-field">
    <app-block-text
      [maxLength]="500"
      type="link"
      [blockData]="block.variables?.['EventImageMobile'] ?? ''"
      (handleOnChange)="onChange($event, 'EventImageMobile')"
      [placeholder]="imageMobilePlaceholder"
      variable="EventImageMobile"
      [isImage]="mobileImageAsUpload"
      [isPlainText]="true"
      [blockId]="block.blockId"
    ></app-block-text>
    <div class="cr-ev-empty-overlay" *ngIf="mobileImageAsUpload && !block.variables?.['EventImageMobile']">
      <div class="cr-ev-icon">
        <svg viewBox="0 0 24 24" width="24" height="24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round">
          <path d="M7.4 18.3H6.2a4.2 4.2 0 0 1-.45-8.38A6.25 6.25 0 0 1 17.83 8.7a4.85 4.85 0 0 1 .02 9.6H16.6" />
          <path d="M12 19.2V11.7" />
          <path d="m8.9 14.8 3.1-3.1 3.1 3.1" />
        </svg>
      </div>
      <div class="cr-ev-title">Upload image</div>
      <div class="cr-ev-subtitle">PNG up to 2 mb</div>
    </div>
  </div>

  <div class="cr-ev-link-field">
    <app-field-editor-v2
      [maxLength]="500"
      type="action-link"
      [blockData]="block.variables?.['EventImageHref'] ?? ''"
      (handleOnChange)="onChange($event, 'EventImageHref')"
      [placeholder]="imageHrefPlaceholder"
      variable="EventImageHref"
      (handleOnSegmentChange)="handleOnSegmentChange($event, 'EventImageHrefSegmentRegex')"
      [selectedSegment]="block.variables?.['EventImageHrefSegmentRegex'] ?? ''"
      [disabled]="disabled"
    ></app-field-editor-v2>
  </div>

  <div class="cr-ev-alt-field">
    <app-field-editor-v2
      [maxLength]="500"
      type="alt"
      [blockData]="block.variables?.['EventImageAlt'] ?? ''"
      (handleOnChange)="onChange($event, 'EventImageAlt')"
      [placeholder]="imageAltPlaceholder"
      variable="EventImageAlt"
      [disabled]="disabled"
    ></app-field-editor-v2>
  </div>

  <app-field-editor-v2
    type="content"
    [multiline]="true"
    [showCounter]="true"
    [blockData]="block.variables?.['EventText'] ?? ''"
    (handleOnChange)="onChange($event, 'EventText')"
    [placeholder]="textPlaceholder"
    [maxLength]="4000"
    variable="EventText"
    [disabled]="disabled"
  ></app-field-editor-v2>

  <div class="cr-ev-link-field">
    <app-field-editor-v2
      type="action-link"
      [blockData]="block.variables?.['EventCtaLink'] ?? ''"
      (handleOnChange)="onChange($event, 'EventCtaLink')"
      [placeholder]="ctaLinkPlaceholder"
      [maxLength]="500"
      variable="EventCtaLink"
      (handleOnSegmentChange)="handleOnSegmentChange($event, 'EventCtaLinkSegmentRegex')"
      [selectedSegment]="block.variables?.['EventCtaLinkSegmentRegex'] ?? ''"
      [disabled]="disabled"
    ></app-field-editor-v2>
  </div>

  <app-field-editor-v2
    type="content"
    [blockData]="block.variables?.['EventCtaText'] ?? ''"
    (handleOnChange)="onChange($event, 'EventCtaText')"
    [placeholder]="ctaTextPlaceholder"
    [maxLength]="30"
    variable="EventCtaText"
    [disabled]="disabled"
  ></app-field-editor-v2>
</div>
